export default __webpack_public_path__ + "static/media/B.c2b77f3e.svg";